import { List } from "@/components/list/List";
import { memo } from "react";

const ProjectSchedulesMenubarComponent = () => {
  return (
    <List.Menubar className="grow my-2">
      <List.Menubar.Tools />
      <List.Menubar.Columns />
      <List.Menubar.Reset />
    </List.Menubar>
  );
};

export const ProjectSchedulesMenubar = memo(ProjectSchedulesMenubarComponent);
